export class ProjectCountAppModel {
	public projectNumber: string;
	public objectCount: number;

	public constructor(proj: string, count: number) {
		this.projectNumber = proj;
		this.objectCount = count;
	}
}
